import { useState } from 'react'

import { Box, Button } from '@mui/material'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'

import Dialog from '~/components/Dialog'

const initialValues = {
  username: '',
  password: '',
  modules: '',
}

const CreateAccountDialog = ({
  isOpenCreateAccountModal,
  setIsOpenCreateAccountModal,
  onSubmit,
}) => {
  const { t } = useTranslation(['mkt'])
  const [visible, setVisible] = useState(false)
  const [error, setError] = useState('')

  return (
    <Dialog
      open={isOpenCreateAccountModal}
      title={t('common.notify')}
      onCancel={() => setIsOpenCreateAccountModal(false)}
      noBorderBottom
    >
      {t('guest.dialog.createAccountModalTitle')}
      <Formik
        initialValues={initialValues}
        // validationSchema={() =>
        //   Yup.object().shape({
        //     username: Yup.string().required(t('form.required')),
        //     password: Yup.string()
        //       .required(t('form.required'))
        //       .min(
        //         TEXTFIELD_REQUIRED_LENGTH.PASSWORD.MIN,
        //         t('form.minLength', {
        //           min: TEXTFIELD_REQUIRED_LENGTH.PASSWORD.MIN,
        //         }),
        //       ),
        //   })
        // }
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ handleChange }) => {
          return (
            <Form>
              {/* <Field.TextField
                name="username"
                label={t('guest.username')}
                placeholder={t('guest.username')}
                inputProps={{
                  maxLength: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
                }}
                onChange={(e) => {
                  handleChange(e)
                  setError('')
                }}
                required
                sx={{ mt: 1 }}
              />
              <Field.TextField
                name="password"
                label={t('guest.password')}
                placeholder={t('guest.password')}
                type={visible ? 'text' : 'password'}
                onChange={(e) => {
                  handleChange(e)
                  setError('')
                }}
                endAdornment={
                  <IconButton
                    onClick={() => setVisible((prevVisible) => !prevVisible)}
                    size="small"
                    sx={{ mx: 0.5 }}
                  >
                    {visible ? (
                      <Icon name="visible" />
                    ) : (
                      <Icon name="invisible" />
                    )}
                  </IconButton>
                }
                required
                sx={{ mt: 1 }}
              />
              <Field.TextField
                name="modules"
                label={t('guest.modules')}
                placeholder={t('guest.modules')}
                inputProps={{
                  maxLength: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
                }}
                sx={{ mt: 1 }}
              />
              {!!error && (
                <FormHelperText error sx={{ mt: 4 / 3 }}>
                  {error}
                </FormHelperText>
              )} */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mt: 2,
                }}
              >
                <Button
                  color="grayF4"
                  sx={{ mr: 1 }}
                  onClick={() => setIsOpenCreateAccountModal(false)}
                >
                  {t('common.cancel')}
                </Button>
                <Button color="primary" type="submit">
                  {t('common.create')}
                </Button>
              </Box>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}

export default CreateAccountDialog
